import MobileSliderPagesHeader from "../../components/MobileSliderPagesHeader";
import { MobileSliderPagesContentStyled } from "../../components/styled/MobileSliderPagesStyled";
import MobileSliderPagesWrapper from "../../components/MobileSliderPagesWrapper";
import MobileHistoryInfo from "../../../MobileHistory/MobileHistoryInfo";
import MobileHistoryInfoHeader from "../../../MobileHistory/MobileHistoryInfoHeader";

function SlideMobileHistoryInfo() {
    return <MobileSliderPagesWrapper backgroundColor="var(--background-base)">
        <MobileSliderPagesHeader goBack>
            <MobileHistoryInfoHeader/>
        </MobileSliderPagesHeader>
        <MobileSliderPagesContentStyled className="px-0">
            <MobileHistoryInfo/>
        </MobileSliderPagesContentStyled>
    </MobileSliderPagesWrapper>
}

export default SlideMobileHistoryInfo;
